import React from 'react';
import { AudioToastProps } from './interfaces';

const AudioToast: React.FC<AudioToastProps> = ({
    showAudioUnlock,
    activateAudio,
    ignoreAudio
}) => {
    if (!showAudioUnlock) {
        return null;
    }

    return (
        <div className="audio-unlock-toast">
            <div className="flex-shrink-0 text-warning">
                <i className="ri-volume-mute-fill fs-24"></i>
            </div>
            <div className="flex-grow-1">
                <p className="mb-0 fs-13 fw-medium">
                    🔇 Tienes nuevas actualizaciones. ¿Deseas activar el sonido?
                </p>
            </div>
            <div className="flex-shrink-0 d-flex gap-2 toast-actions">
                <button
                    onClick={ignoreAudio}
                    className="btn btn-sm btn-ghost-secondary px-2"
                    aria-label="Ignorar notificaciones sonoras"
                >
                    Ignorar
                </button>
                <button
                    onClick={activateAudio}
                    className="btn btn-sm btn-primary px-3"
                    aria-label="Activar notificaciones sonoras"
                >
                    Activar
                </button>
            </div>
        </div>
    );
};

export default AudioToast;
